export default __webpack_public_path__ + "static/media/PG.6e963cfa.ico";